export default "__VITE_ASSET__DPGHSxyV__"